/**
 * Utilidades de fecha compartidas en el módulo booking.
 *
 * REGLA: todas las fechas que viajan entre frontend, fachada y microservicio
 * se interpretan como HORA LOCAL de la location (sin 'Z' ni offset).
 * Por ello NO usamos `Date.toISOString()` (que emite en UTC con 'Z').
 */

/**
 * Devuelve un ISO 8601 en hora local del navegador, SIN 'Z' ni offset.
 * Formato: "yyyy-MM-ddTHH:mm:ss".
 *
 * Úsalo en lugar de `d.toISOString()` siempre que el valor vaya al backend
 * de booking.
 */
export function formatLocalIso(d: Date): string {
  const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
  return d.getFullYear() + '-' +
    pad(d.getMonth() + 1) + '-' +
    pad(d.getDate()) + 'T' +
    pad(d.getHours()) + ':' +
    pad(d.getMinutes()) + ':' +
    pad(d.getSeconds());
}

/**
 * Normaliza un valor entrante (Date, string "yyyy-MM-ddTHH:mm" o similar)
 * a ISO local "yyyy-MM-ddTHH:mm:ss" sin TZ. Devuelve null si el valor es
 * vacío o no interpretable.
 */
export function toLocalIsoOrNull(value: any): string | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return formatLocalIso(value);
  }

  if (typeof value === 'string') {
    // "yyyy-MM-ddTHH:mm" -> añadimos segundos y lo tratamos como local
    if (value.length === 16) {
      value = value + ':00';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return null;
    }
    return formatLocalIso(d);
  }

  return null;
}
